import Mention from '@tiptap/extension-mention';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { VariableChip } from '../comps/VariableChip';

/**
 * Inline atomic mention node (keeps Tiptap Mention's `id`/`label` attrs and atom/inline
 * behaviour — whole-chip backspace, caret steps over) rendered by the React `VariableChip`.
 * The `#` suggestion is supplied via `.configure({ suggestion })` in FormulaInput.
 */
export const VariableMention = Mention.extend({
  addAttributes() {
    return {
      ...this.parent?.(), // Mention's `id` + `label`
      // Optional value/currency captured at insert time (e.g. just-saved via "+ Add Value")
      // so the chip can display immediately, before the variables refetch lands. Live context
      // remains the source of truth; these are a fallback only. Not serialized to HTML.
      value: { default: null, rendered: false },
      currency: { default: null, rendered: false },
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(VariableChip);
  },
});
